import { render, staticRenderFns } from "./FechasCorte.vue?vue&type=template&id=2d68ed6c&scoped=true"
import script from "./FechasCorte.vue?vue&type=script&lang=js"
export * from "./FechasCorte.vue?vue&type=script&lang=js"
import style0 from "./FechasCorte.vue?vue&type=style&index=0&id=2d68ed6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68ed6c",
  null
  
)

export default component.exports